import '../../index.scss';

const HeroSection = () => {
    return (
        <section id="intro" className="wrapper style1 fullscreen fade-up">
            <div className="inner">
                <h1>
                    <span>&lt; </span>
                    <img src='/logo.svg' width={40} height={40} alt='logo dev.cyrkran'/>
                    <span>dev.cyrkran</span>
                    <span>/&gt;</span>
                </h1>
                <p>Somos uma empresa dedicada a oferecer soluções digitais completas para impulsionar o sucesso do seu negócio.<br/>
                    Desde a criação de landing pages e blogs até e-commerces e dashboards personalizados, garantimos segurança, confiabilidade e design sob medida para suas necessidades.</p>
                <ul className="actions">
                    <li><a href="#one" className="button scrolly">Learn more</a></li>
                </ul>
            </div>
        </section>
    )
}

export default HeroSection